module.exports = __webpack_public_path__ + "static/img/shibie.1ad183f2.jpg";